import { createSelector } from 'reselect';

import { createParameterSelector } from '@pressreader/appstore';

import { type CommentsDialogResultCommentsMetadata } from '../../types/comments.dialog';

import { selectTotalCommentsCount } from './comments';
import { selectArticleId, selectIsDialogOpenedOrOpening, selectPopupId } from './common';

const selectArticleIdParameter = createParameterSelector<'articleId', string>('articleId');

export const selectIsCommentsDialogForArticleIdOpened = createSelector(
    selectArticleIdParameter,
    selectIsDialogOpenedOrOpening,
    selectArticleId,
    (articleId: string, isPopupDialogOpenOrOpening: boolean, currentArticleId: string): boolean => {
        if (articleId === currentArticleId && isPopupDialogOpenOrOpening) {
            return true;
        }
        return false;
    },
);

const selectPopupIdParameter = createParameterSelector<'popupId', string>('popupId');

export const selectCommentsDialogResultCommentsMetadata = createSelector(
    selectPopupIdParameter,
    selectArticleId,
    selectPopupId,
    selectTotalCommentsCount,
    (
        popupIdRequested: string,
        articleId: string,
        currentPopupId: string,
        totalCommentsCount: number,
    ): CommentsDialogResultCommentsMetadata | null => {
        if (popupIdRequested !== currentPopupId) {
            return null;
        }
        return {
            articleId,
            totalCommentsCount,
        };
    },
);
